import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppSettings } from "../../../../settings/app.settings";
import { HttpClientService } from "../../../../utilities/http.client";
import { ISampleBlendInfoModel } from "../../../../models/sample-blend-info.model";
import { BlendInputInformation } from '../../../../../app/models/feza-viewmodels/blend-input-information.model';//../subsample-blend/shared/src/viewmodels/BlendInputInformation
import { BlendMember } from '../../../../../app/models/feza-viewmodels/blend-member.model';//../subsample-blend/shared/src/viewmodels/BlendMember
import { IS1Question } from '../../../../../app/interfaces/feza/s1-question.interface';//../models/s1/IS1Question
import { IS1Answer } from '../../../../../app/interfaces/feza/s1-answer.interface';//../models/s1/IS1Question
import { ISupplierAndGroupList } from "../../../../interfaces/feza/suppliers-and-group-list.interface";
import { BlendLockModel } from "../../../../models/feza-viewmodels/blend-locked.model";
import { ISupplierAutoblend } from '../../../../../app/interfaces/feza/supplier-autoblend.interface';//../models/s1/IS1Question
import { SupplierListItem } from "../../../../models/feza-viewmodels/supplier-list-item.model";
import { IBidResponse } from "../../../../interfaces/feza/bid-response.interface";
import { ISampleBlendGroupSupplierModel } from "../../../../models/sample-blend-group-supplier.model";
import { IQuotaRowModel } from "../../../../models/quota-row.model";

@Injectable()

export class SampleBlendService {
  constructor(
    private appSettings: AppSettings,
    private http: HttpClientService
  ) {}

  private urls = {
    getBlendInfo: `${this.appSettings.AdminApiPath}SampleBlendInfo/{subsampleId}`,
    getBlendSuppliersByGroupId: `${this.appSettings.AdminApiPath}GetBlendSuppliersByGroupId`,
    getSuppliersAutoblend: `${this.appSettings.AdminApiPath}SuppliersAutoblend/{subsampleId}?countryId={countryId}`,
    getSuppliersCountryAutoblend: `${this.appSettings.AdminApiPath}SuppliersCountryAutoblend/{subsampleId}?countryId={countryId}`,
    getDefaultBlend: `${this.appSettings.AdminApiPath}SuggestedBlend/{subsampleId}`,
    saveBlend: `${this.appSettings.AdminApiPath}SampleBlend/{subsampleId}?feasibilityId={feasibilityId}`,
    saveBlendSuppliersOfGroup: `${this.appSettings.AdminApiPath}SaveBlendSuppliersOfGroup/{surveyId}`,
    isRequestFezaBlendsButtonDisabled: `${this.appSettings.AdminApiPath}Event/IsRequestFezaBlendsButtonDisabled`,
    requestFezaBlends: `${this.appSettings.AdminApiPath}Event/RequestFezaBlends`,
    checkAndRequestFezaBlends: `${this.appSettings.AdminApiPath}Event/RequestFezaBlendsForManualSubsamples`,
    getS1Questions: `${this.appSettings.AdminApiPath}/common/1/locales/{locale}/questions`,
    getS1Answers: `${this.appSettings.AdminApiPath}/common/1/locales/any/questions/{questionId}/answers`,
    getSuppliersAndGroups: `${this.appSettings.AdminApiPath}SampleBlendInfo/SuppliersAndGroups/{subsampleId}`,
    getSuppliersAndGroupsSearch: `${this.appSettings.AdminApiPath}SampleBlendInfo/SuppliersAndGroupsSearch/{subsampleId}/{search}`,
    getBlendLock: `${this.appSettings.AdminApiPath}SampleBlendInfo/BlendLocked/{subsampleId}`,
    minutesToPassBetween2SupplierListCalls: `${this.appSettings.AdminApiPath}SampleBlendInfo/MinutesToPassBetween2SupplierListCalls`,
    getSystemBlendAppliedMessage: `${this.appSettings.AdminApiPath}SampleBlendInfo/SystemBlendAppliedMessage`,
    getSuppliersAndGroupsListByCountry: `${this.appSettings.AdminApiPath}SuppliersAndGroupsListByCountry/{subsampleId}?countryId={countryId}`,
    getMinutesToPassUntilSupplierScreenLoadsAllSuppliers: `${this.appSettings.AdminApiPath}SampleBlendInfo/MinutesToPassUntilSupplierScreenLoadsAllSuppliers`,
    getManualFeasibility: `${this.appSettings.AdminApiPath}ManualFeasibility?eventId={eventId}&correlationId={correlationId}`,
    OpenBlendForQuotas: `${this.appSettings.AdminApiPath}OpenBlendForQuotas/{subsampleId}`,
    getSubsampleUsesAutomatedBlendMessage: `${this.appSettings.AdminApiPath}GetSystemSettingsValue/{key}`,
  };

  getSuppliersAndGroups = (subsampleId: number): Observable<ISupplierAndGroupList> =>
    this.http.postSubscription(this.urls.getSuppliersAndGroups, { subsampleId: subsampleId });


  getSuppliersAndGroupsSearch = (subsampleId: number, search: string): Observable<ISupplierAndGroupList> =>
    this.http.postSubscription(this.urls.getSuppliersAndGroupsSearch, { subsampleId: subsampleId, search: search });
  
  getBlendInfo = (subsampleId: number): Observable<ISampleBlendInfoModel> =>
    this.http.getSubscription(this.urls.getBlendInfo, { subsampleId: subsampleId });

  getBlendSupplierByGroupId = (groupId: number, surveyId: number): Observable<ISampleBlendGroupSupplierModel[]> =>
    this.http.getSubscription(this.urls.getBlendSuppliersByGroupId, {groupId, surveyId})

  getManualFeasibility = (eventId: number, correlationId: string, quotaAllocationMode: string, panelCheckTargetingMode: string, storeResponsesForReporting: boolean): Observable<IBidResponse> => {
    return this.http.postSubscription(this.urls.getManualFeasibility, { eventId: eventId, correlationId: correlationId, quotaAllocationMode: quotaAllocationMode, panelCheckTargetingMode: panelCheckTargetingMode, storeResponsesForReporting: storeResponsesForReporting })
  };

  getSuppliersAutoblend = (subsampleId: number, countryCode: string): Observable<ISupplierAutoblend[]> =>
    this.http.getSubscription(this.urls.getSuppliersAutoblend, { subsampleId: subsampleId, countryCode: countryCode});

  getSuppliersCountryAutoblend = (subsampleId: number, countryCode: string): Observable<ISupplierAutoblend[]> =>
    this.http.getSubscription(this.urls.getSuppliersCountryAutoblend, { subsampleId: subsampleId, countryCode: countryCode });

  getDefaultBlend = (subsampleId: number, feasibilityId: string): Observable<BlendInputInformation> =>
    this.http.getSubscription(this.urls.getDefaultBlend, { subsampleId: subsampleId, feasibilityId: (feasibilityId || "") });

  saveBlend = (subsampleId: number, blend: BlendInputInformation, isBlendGroupped: boolean): Observable<boolean> =>
    this.http.postSubscription(this.urls.saveBlend, { subsampleId: subsampleId, isBlendGroupped }, blend);

  saveBlendSuppliersOfGroup = (surveyId: number, suppliers: ISampleBlendGroupSupplierModel[]): Observable<boolean> =>
    this.http.postSubscription(this.urls.saveBlendSuppliersOfGroup, { surveyId: surveyId }, suppliers);

  isRequestFezaBlendsButtonDisabled = (surveyEventId: number): Observable<number> =>
    this.http.getSubscription(this.urls.isRequestFezaBlendsButtonDisabled, { surveyEventId: surveyEventId });

  requestFezaBlends = (surveyEventId: number): Observable<boolean> =>
    this.http.getSubscription(this.urls.requestFezaBlends, { surveyEventId: surveyEventId });

  checkAndRequestFezaBlends = (surveyId: number, surveyEventId: number): Observable<boolean> =>
        this.http.getSubscription(this.urls.checkAndRequestFezaBlends, { surveyId: surveyId, surveyEventId: surveyEventId });
  getS1Questions = (locale: string): Observable<IS1Question[]> =>
        this.http.getSubscription(this.urls.getS1Questions, { locale: locale }); s

  getS1Answers = (questionId: number): Observable<IS1Answer[]> =>
    this.http.getSubscription(this.urls.getS1Answers, { questionId: questionId });

  getBlendLock = (subsampleId: number): Observable<BlendLockModel> =>
    this.http.getSubscription(this.urls.getBlendLock, { subsampleId: subsampleId });

  getNoOfMinutesBetween2SupplierListCalls = (): Observable<number> =>
    this.http.getSubscription(this.urls.minutesToPassBetween2SupplierListCalls, {});

  getSystemBlendAppliedMessage = (): Observable<string> =>
    this.http.getSubscription(this.urls.getSystemBlendAppliedMessage, {});

  getSuppliersAndGroupsListByCountry = (subsampleId: number, countryCode: string): Observable<SupplierListItem[]> =>
    this.http.getSubscription(this.urls.getSuppliersAndGroupsListByCountry, { subsampleId: subsampleId, countryCode: countryCode });

  getMinutesToPassUntilSupplierScreenLoadsAllSuppliers = (): Observable<number> =>
    this.http.getSubscription(this.urls.getMinutesToPassUntilSupplierScreenLoadsAllSuppliers, {});

  OpenBlendForQuotas = (subsampleId: number, openQuotas: IQuotaRowModel[]): Observable<boolean> =>
    this.http.postSubscription(this.urls.OpenBlendForQuotas, { subsampleId: subsampleId }, openQuotas);

  getSubsampleUsesAutomatedBlendMessage = (key: string): Observable<string> =>
    this.http.getSubscription(this.urls.getSubsampleUsesAutomatedBlendMessage, {key: key});
}


